import reframe from 'reframe.js';

export const responsiveVideoLoad = () => {
  reframe(".responsive-video");
}